import React, { useRef, useEffect } from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import _isFunction from 'lodash/isFunction.js';
import { useUpdateEffect } from '../hooks/useUpdateEffect.js';

export function ColorPreviewTile(props) {

  const {
    color, 
    index, 
    active, 
    metallic, 
    onClickCallback,
    onMouseEnterCallback,
    onMouseLeaveCallback
  } = props;

  const block = 'c-color-preview-tile';
  const tabRef = useRef();
  const colorCode = color => color.rgb || color.hexCode || color.hex;
  const dualToneColor = Array.isArray(colorCode(color)) && colorCode(color).length > 1;

  useEffect(() => {
    if (active) {
      tabRef.current.focus();
      setTimeout(() => {
        tabRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }, 500);
    }
  }, [active]);

  function clickHandler(e) {
    if (_isFunction(onClickCallback)) {
      onClickCallback(e, color, index);
    }
  };

  function mouseEnterHandler(e) {
    if (_isFunction(onMouseEnterCallback)) {
      onMouseEnterCallback(e, color, index);
    }
  };

  function mouseLeaveHandler(e) {
    if (_isFunction(onMouseLeaveCallback)) {
      onMouseLeaveCallback(e, color, index);
    }
  };

  return (
    <button 
    ref={tabRef}
    className={
      classNames({
        [`${block}`]: true,
        [`${block}--active`]: active
      })
    }
    onClick={clickHandler} 
    onMouseEnter={mouseEnterHandler} 
    onMouseLeave={mouseLeaveHandler}
    >
      <span 
      className={
        classNames({
          [`${block}__color-container`]: true,
          [`${block}__color-container--metallic-overlay`]: metallic,
        })
      }
      style={
        dualToneColor ? 
          { background: `linear-gradient(180deg, #${colorCode(color)[0]} 50%, #${colorCode(color)[1]} 50%)`} : 
          { backgroundColor: `#${colorCode(color)}` }
      }
      >
      </span>
    </button>
  )
};

ColorPreviewTile.propTypes = {
  color: propTypes.object.isRequired,
  index: propTypes.number.isRequired,
  active: propTypes.bool,
  metallic: propTypes.bool,
  onClickCallback: propTypes.func,
  onMouseEnterCallback: propTypes.func,
  onMouseLeaveCallback: propTypes.func
};

ColorPreviewTile.defaultProps = {
  active: false
};